import { Component, OnInit, inject } from '@angular/core';
import { VariablesGlobalesService } from '../../services/variables-globales.service';
import { ModalController,IonButton, IonButtons, IonHeader, IonTitle, IonToolbar, IonIcon, IonGrid, IonRow, IonCol } from "@ionic/angular/standalone";

import { IconoCieloPipe } from '../../pipes/iconoCielo.pipe';

@Component({
    selector: 'app-meteorologia',
    templateUrl: './meteorologia.component.html',
    styleUrls: ['./meteorologia.component.scss'],
    standalone: true,
    imports: [IonHeader,IonToolbar,IonTitle,IonButtons, IonButton, IonIcon, IonGrid, IonRow, IonCol, IconoCieloPipe]
})
export class MeteorologiaComponent implements OnInit {
  variables = inject(VariablesGlobalesService);
  modalController = inject(ModalController);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  ngOnInit() {}
}
